// extracted by css-extract-rspack-plugin
export default {"text-input":"text-input___eIX9oYWM"};